/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.25 12a.75.75 0 0 0 .75.75h5.25V18a.75.75 0 0 0 1.5 0v-5.25H18a.75.75 0 0 0 0-1.5h-5.25V6a.75.75 0 0 0-1.5 0v5.25H6a.75.75 0 0 0-.75.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.6 0h12.8C21.4928 0 24 2.5072 24 5.6v12.8c0 3.0928-2.5072 5.6-5.6 5.6H5.6C2.5072 24 0 21.4928 0 18.4V5.6C0 2.5072 2.5072 0 5.6 0Zm12.8 1.6H5.6c-2.2091 0-4 1.7909-4 4v12.8c0 2.2091 1.7909 4 4 4h12.8c2.2091 0 4-1.7909 4-4V5.6c0-2.2091-1.7909-4-4-4Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Create'
);
